<template>
   <v-container fluid>
       <v-row class="pa-2">
           <v-data-table dense style="width: 100%;" :height="getHeight"
                         :footer-props="{
                            pagination: {
                            itemsPerPage: 100
                            }
                         }"
                         :headers="headers" :items="ROWS.data">
               <template v-slot:item="{item}">
                   <tr>
                       <td>{{item.user_id}}</td>
                       <td>{{new Date(item.log_date).toLocaleString()}}</td>
                   </tr>
               </template>
           </v-data-table>
       </v-row>
   </v-container>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: "ReportTools",

    computed: {
      ...mapGetters('reports/',{
        ROWS: 'TOOLS'
      }),
      getHeight () {
        return document.body.offsetHeight - 150
      },
    },

    data() {
      return {
        headers: [
          {text: 'User Email', value: 'user_id', sortable: true},
          {text: 'Date/Time', value: 'log_date', sortable: true},
        ]
      }
    }
  }
</script>

<style scoped>

</style>
